import { render, staticRenderFns } from "./answerVisit.vue?vue&type=template&id=4440c85a&scoped=true&"
import script from "./answerVisit.vue?vue&type=script&lang=js&"
export * from "./answerVisit.vue?vue&type=script&lang=js&"
import style0 from "./answerVisit.vue?vue&type=style&index=0&id=4440c85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4440c85a",
  null
  
)

export default component.exports